export const INFO = {
  TITLE: 'National ID',
  NATIONAL_ID_REQUIRED: '14-digit National ID is required',
  NATIONAL_ID_VALIDATION: 'National ID is not valid',
  BTN: 'Continue',
};
